import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { IChildrenProp } from 'types/components/components.interface';
import './LabelFormTemplate.scss';

interface ILabelFormTemplateProps extends IChildrenProp {
  header?: ReactNode;
  description?: ReactNode;
  footer?: ReactNode;
  steps?: ReactNode;
  top?: ReactNode;
}

const LabelFormTemplate = ({
  header,
  description,
  children,
  steps,
  top,
}: ILabelFormTemplateProps) => {
  const { t } = useTranslation();
  return (
    <div className='label-form-wrapper'>
      <div className='label-form-top'>{top}</div>
      <div className='label-form'>
        <div className='label-form-header'>
          <p className='main'>{header}</p>
          <p>{description}</p>
        </div>
        <div className='label-form-steps'>{steps}</div>
        <div className='label-form-content'>{children}</div>
      </div>
    </div>
  );
};

export default LabelFormTemplate;
